import { HStack, Link, Text } from "@chakra-ui/react";
import useTranslate from "@raiden/library/hooks/useTranslate";
import { getMenuItemAdapterValues } from "../../../../../../helpers/menus/getMenuItemAdapterValues";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Configuration").ConfigurationMenuItem} menuItem
 */
/**
 * @param {Props} props
 */
export function SubMenuItem({ menuItem }) {
  const translate = useTranslate();

  const { title, href, target } = getMenuItemAdapterValues({
    menuItem,
    translate,
  });

  return (
    <HStack
      minH="61px"
      spacing="0"
      borderColor="gray.400"
      _notFirst={{ borderTopWidth: "1px" }}>
      <Link
        href={href}
        target={target}
        fontSize="0.875rem"
        fontWeight={400}
        lineHeight="1.3125rem"
        color="white">
        <HStack>
          <Text>{title}</Text>
        </HStack>
      </Link>
    </HStack>
  );
}
